import Cookies from "js-cookie";
import axios from "axios";
import { CognitoUserAttribute } from 'amazon-cognito-identity-js'
import Pool from '../UserPool'

const getSession = async () => {
  return await new Promise((resolve, reject) => {
    const user = Pool.getCurrentUser();
    if (user) {
      user.getSession((err, session) => {
        if (err) {
          reject();
        } else {
          const attributes = new Promise((resolve,reject)=>{
            user.getUserAttributes((err,attributes)=>{
              if (err) {
                reject();
              } else {
          const results={};
          for(let attribute of attributes)
          {
            const {Name,Value}=attribute;
            results[Name]=Value
          }
          resolve(results);
        }
      
      });
    });
      resolve({user, ...session,...attributes});
    } });} else {
      reject();
    }
  });
};
const GetURL =
  "https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/get-form-values";
  const GetViewURL =
  "https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/viewproperty";
const DelURL =
  "https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/delete";
const getdefault=
"https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/getdefaults";
const URL =
  "https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily";
  export async function editdefaultvalues(arr, formId, imageArr = null, tabs = null,clickID) {

    let Tab=clickID.split('-')[0];
  
    let Section=clickID.split('-')[1];
    let params = {
      Deafults:"AdminDefaults",
      Stage:"L",
      Tab:Tab,
      Section:Section,
      formId: formId,
      username: Cookies.get("username"),
      group: Cookies.get("Group"),
      CityId: 1,//JSON.parse(Cookies.get("city")).CityId,
      parameters: [],
      // StructureImages: [],
    };
  

  
    if (tabs) {
      console.log(tabs);
      params.StructureTypes = Object.entries(tabs).map((item) => {
        if(item[0]==Tab)
        {
        let keysArr = Object.keys(item[1]);
        let arr = [];
        keysArr.forEach((key, index) => {
          if(Section !="All"){
          if(item[1][key][0].Phase==Section){
          arr = arr.concat(
            item[1][key].map((item) => ({
             
              ParameterId: item.ParameterId.toString(),
              ParameterName: item.ParameterName,
              value: item.value,
              ischecked:item.ischecked,
              isComplete: item.isComplete,
              Phase: item.Phase,
              ParameterTypeId: item.ParameterTypeId,
              ParamOrder: item.ParamOrder,
              perhomevalue: item.perhomevalue,
                perprojectvalue: item.perprojectvalue,
            }))
          );}}
          else if(Section=="All"){
            arr = arr.concat(
              item[1][key].map((item) => ({
             
                ParameterId: item.ParameterId.toString(),
                ParameterName: item.ParameterName,
                value: item.value,
                ischecked:item.ischecked,
                isComplete: item.isComplete,
                Phase: item.Phase,
                ParameterTypeId: item.ParameterTypeId,
                ParamOrder: item.ParamOrder,
                perhomevalue: item.perhomevalue,
                perprojectvalue: item.perprojectvalue,
              
              }))
            )
          }
        });
        return {
          StructureType: item[0],
          Calculations: arr,
        };
      }
      else{
        return {
          StructureType: "",
          Calculations: [],
        };
      }
      });
    }
    else{
      params.StructureTypes=[]
    }
  
    params = JSON.stringify({
      Body: params,
    });
    console.log(params);
  
    // return response;
  
    return axios
      .post(URL, params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        crossorigin: true,
      })
      .then((res) => {
  
        console.log("Here data",res.data);
        //return res.data;
      })
      .catch((e) => {
      });
  }
  export async function editdefaultvaluesuser(arr, formId, imageArr = null, tabs = null,clickID,defaults) {

    let Tab=clickID.split('-')[0];
  
    let Section=clickID.split('-')[1];
    let params = {
      Deafults:"UserDefaults",
      userType:defaults,
      Stage:"L",
      Tab:Tab,
      Section:Section,
      formId: formId,
      username: Cookies.get("username"),
      group: Cookies.get("Group"),
      CityId: 1,//JSON.parse(Cookies.get("city")).CityId,
      parameters: [],
      // StructureImages: [],
    };
  

  
    if (tabs) {
    
      params.StructureTypes = Object.entries(tabs).map((item) => {
        if(item[0]==Tab)
        {
        let keysArr = Object.keys(item[1]);
        let arr = [];
        keysArr.forEach((key, index) => {
          if(Section !="All"){
          if(item[1][key][0].Phase==Section){
          arr = arr.concat(
            item[1][key].map((item) => ({
             
              ParameterId: item.ParameterId.toString(),
              ParameterName: item.ParameterName,
              value: item.value,
              ischecked:item.ischecked,
              isComplete: item.isComplete,
              Phase: item.Phase,
              ParameterTypeId: item.ParameterTypeId,
              ParamOrder: item.ParamOrder,
              perhomevalue: item.perhomevalue,
                perprojectvalue: item.perprojectvalue,
            }))
          );}}
          else if(Section=="All"){
            arr = arr.concat(
              item[1][key].map((item) => ({
             
                ParameterId: item.ParameterId.toString(),
                ParameterName: item.ParameterName,
                value: item.value,
                ischecked:item.ischecked,
                isComplete: item.isComplete,
                Phase: item.Phase,
                ParameterTypeId: item.ParameterTypeId,
                ParamOrder: item.ParamOrder,
                perhomevalue: item.perhomevalue,
                perprojectvalue: item.perprojectvalue,
              
              }))
            )
          }
        });
        return {
          StructureType: item[0],
          Calculations: arr,
        };
      }
      else{
        return {
          StructureType: "",
          Calculations: [],
        };
      }
      });
    }
    else{
      params.StructureTypes=[]
    }
  
    params = JSON.stringify({
      Body: params,
    });
    console.log(params);
  
    // return response;
  
    return axios
      .post(URL, params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        crossorigin: true,
      })
      .then((res) => {
  
        console.log("Here data",res.data);
        //return res.data;
      })
      .catch((e) => {
      });
  }
  export async function getDefaultvalues() {
    var name=Cookies.get('username');
  
    let params = {
      UserName: name,
      Stage:"L",
      userType:"Admin"
    };
    params = JSON.stringify({
      Body: params,
    });
    console.log(params)
    return axios
      .post(getdefault, params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        crossorigin: true,
      })
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        alert(e.message);
      });
  }
  export async function getUserDefault() {
    var name=Cookies.get('username');
    
    let params = {
      UserName: name,
      Stage:"L",
      userType:"User"
    };
    params = JSON.stringify({
      Body: params,
    });
    console.log(params)
    return axios
      .post(getdefault, params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        crossorigin: true,
      })
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        alert(e.message);
      });
  }
  export async function getAutoPopulateData(Lat,Lng,address) {
    
    const url = 'https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/autopopulate';
    let params = {SearchString:address,Latitude:Lat,longitude:Lng, Stage:"P"};
    params = JSON.stringify({
      Body: params,
    });
   console.log(params)
    return axios.post(url,  params ,{
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      crossorigin: true,
    }).then(res => {
      console.log(res);
        return res.data;
    })
    .catch(e => {
     
    })
}
  export async function getWalkScoreData(Lat,Lng,address) {
    const url = 'https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/walkscore';
    let params = {address:address,Latitude:Lat,Longitude:Lng};
    params = JSON.stringify({
      Body: params,
    });
   console.log(params)
    return axios.post(url,  params ,{
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      crossorigin: true,
    }).then(res => {
      console.log(res);
        return res.data;
    })
    .catch(e => {
     
    })
}
  export async function getSoundScoreData(Lat,Lng) {

    const params = new URLSearchParams();
    params.append('lng', Lng);
    params.append('lat', Lat);
    params.append('x-api-key', 'eH6lZEPo9E80fflcZAot613lcmtOLQ9hcUT7AHl8');
    axios.get('https://api.howloud.com/score?lng=-122.3373775&lat=47.6190756&x-api-key=eH6lZEPo9E80fflcZAot613lcmtOLQ9hcUT7AHl8')
   .then(res => {
      console.log(res);
        return res.data.result.scoretext;
    })
    .catch(e => {
        alert("Sound Score "+e.message)
    })
}

export async function addFormPost(arr, formId, imageArr = null) {

  var PerClick=Cookies.get('UsedClicks');
  var PerMonthClick=Cookies.get('PerMonthClick');
  let num = parseInt(PerMonthClick, 10);
  let num1 = parseInt(PerClick, 10);
  num1=num1+1;

  getSession().then(({ user }) => {
    const attributes = [
      new CognitoUserAttribute({ Name: "custom:UsedClicks", Value: num1.toString() }),
    ];
    user.updateAttributes(attributes, (err, result) => {
      if (err) console.error(err);
      console.log(result);
      if(result=="SUCCESS"){
      }      
    });
  });
  Cookies.set('UsedClicks', num1)

  let params = {
    Stage:"L",
    Tab:'',
    Section:'',
    formId: formId,
    username: Cookies.get("username"),
    group: Cookies.get("Group"),
    CityId: 1,//JSON.parse(Cookies.get("city")).CityId,
    parameters: [],
    StructureImages: [],
  };
  
  console.log("Form", arr);
  let Arr = [];
  arr.map(async (item) => {
    Arr.push({
      ParameterId: item.ParameterId,
      ParameterName: item.ParameterName,
      value: item.Value,
      Phase: item.Phase,
      ParameterTypeId: item.ParameterTypeId,
      ParamOrder: item.ParamOrder,
    });
  });
 
  params.parameters = Arr;

  // if (Object.keys(imageArr).length != 0) {
  //   let keysArr = Object.keys(imageArr);
  //   let arr = [];
  //   keysArr.forEach((key, index) => {
  //     arr = arr.concat(imageArr[key]);
  //   });
  //   params.StructureImages = arr;
  // }
  // params.StructureTypes=[];
  console.log("fff", params);
  params = JSON.stringify({
    Body: params,
  });
  console.log(params);

   //return params;

  return axios
    .post(URL, params, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      crossorigin: true,
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      
    });
}

export async function editFormPost(arr, formId, imageArr = null, tabs = null,clickID) {

  let Tab=clickID.split('-')[0];

  let Section=clickID.split('-')[1];
  let params = {
    Stage:"L",
    Tab:Tab,
    Section:Section,
    formId: formId,
    username: Cookies.get("username"),
    group: Cookies.get("Group"),
    CityId: 1,//JSON.parse(Cookies.get("city")).CityId,
    parameters: [],
    // StructureImages: [],
  };

  let Arr = [];
  arr.map(async (item) => {
    Arr.push({
      ParameterId: item.ParameterId,
      ParameterName: item.ParameterName,
      value: item.Value,
      Phase: item.Phase,
      ParameterTypeId: item.ParameterTypeId,
      ParamOrder: item.ParamOrder,
    });
  });
  params.parameters = Arr;

  if (Object.keys(imageArr).length != 0) {
    let keysArr = Object.keys(imageArr);
    let arr = [];
    keysArr.forEach((key, index) => {
      arr = arr.concat(imageArr[key]);
    });
    params.StructureImages = arr;
  }

  if (tabs) {
    console.log(tabs);
    params.StructureTypes = Object.entries(tabs).map((item) => {
      if(item[0]==Tab)
      {
      let keysArr = Object.keys(item[1]);
      let arr = [];
      keysArr.forEach((key, index) => {
        if(Section !="All"){
        if(item[1][key][0].Phase==Section){
        arr = arr.concat(
          item[1][key].map((item) => ({
           
            ParameterId: item.ParameterId.toString(),
            ParameterName: item.ParameterName,
            value: item.value,
            ischecked:item.ischecked,
            isComplete: item.isComplete,
            Phase: item.Phase,
            ParameterTypeId: item.ParameterTypeId,
            ParamOrder: item.ParamOrder,
            perhomevalue: item.perhomevalue,
              perprojectvalue: item.perprojectvalue,
          }))
        );}}
        else if(Section=="All"){
          arr = arr.concat(
            item[1][key].map((item) => ({
           
              ParameterId: item.ParameterId.toString(),
              ParameterName: item.ParameterName,
              value: item.value,
              ischecked:item.ischecked,
              isComplete: item.isComplete,
              Phase: item.Phase,
              ParameterTypeId: item.ParameterTypeId,
              ParamOrder: item.ParamOrder,
              perhomevalue: item.perhomevalue,
              perprojectvalue: item.perprojectvalue,
            
            }))
          )
        }
      });
      return {
        StructureType: item[0],
        Calculations: arr,
      };
    }
    else{
      return {
        StructureType: "",
        Calculations: [],
      };
    }
    });
  }
  else{
    params.StructureTypes=[]
  }

  params = JSON.stringify({
    Body: params,
  });
  console.log(params);

  // return response;

  return axios
    .post(URL, params, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      crossorigin: true,
    })
    .then((res) => {

      console.log("Here data",res.data);
      //return res.data;
    })
    .catch((e) => {
    });
}

export async function getFormData(form_id) {
  let params = {
    FormId: form_id,
    Stage:"L"
  };
  params = JSON.stringify({
    Body: params,
  });
  console.log("getform",params);
  return axios
    .post(GetURL, params, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      crossorigin: true,
    })
    .then((res) => {
      console.log("getform",res.data);
      return res.data;
    })
    .catch((e) => {
      alert(e.message);
    });
}
export async function getFormDataView(form_id) {
  let params = {
    FormId: form_id,
    Stage:"L"
  };
  params = JSON.stringify({
    Body: params,
  });
  return axios
    .post(GetViewURL, params, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      crossorigin: true,
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      alert(e.message);
    });
}
export async function deleteFormData(form_id) {
  let params = {
    FormId: form_id,
    Stage:"L"
  };
  params = JSON.stringify({
    Body: params,
  });
  return axios
    .post(DelURL, params, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      crossorigin: true,
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      alert(e.message);
    });
}
